import { AppBar, Toolbar, Typography } from "@mui/material";
import { COLORS } from "components";
import React from "react";

interface InfoMessageBarProps {
    children: React.ReactNode;
}

export const InfoMessageBar: React.FC<InfoMessageBarProps> = ({ children }) => (
    <AppBar
        position="static"
        sx={{
            backgroundColor: COLORS.Romance,
            height: "23px",
            top: "auto",
            bottom: 0,
            textAlign: "center",
            marginBottom: 2,
            width: "100%",
        }}
    >
        <Toolbar
            sx={{
                color: "white",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Typography sx={{ mb: 5 }} align="center">
                {children}
            </Typography>
        </Toolbar>
    </AppBar>)
